import { render } from "./SurchargeIndex.vue?vue&type=template&id=435c8396"
import script from "./SurchargeIndex.vue?vue&type=script&lang=js"
export * from "./SurchargeIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__